import { FC } from "react";
import Emojify from "~/components/shared/Emojify";
import { ProcessedEmoji } from "~/components/shared/NavatarPicker/index";

export interface FooterSectionProps {
  displayEmoji?: ProcessedEmoji | null;
}

const FooterSection: FC<FooterSectionProps> = ({ displayEmoji }) => {
  return (
    <div className="flex h-20 w-full items-center justify-between border-t border-gray-200 bg-white px-4">
      <a
        href="https://github.com/buildkite/emojis#contributing-a-new-emoji"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-small btn-depth btn-flex text-nowrap"
      >
        Add Emoji
      </a>

      {displayEmoji && (
        <div className="flex h-fit min-w-0 items-center gap-2">
          <div className="flex min-w-0 flex-col items-end justify-center gap-1">
            <span className="text-charcoal-200 max-w-36 truncate text-right font-normal leading-none">
              {displayEmoji.name.replace(/-/g, " ")}
            </span>
            <span className="text-charcoal-400 max-w-36 truncate text-right text-xs font-normal leading-none">
              :{displayEmoji.name}:
            </span>
          </div>
          <Emojify
            className="mt-1 flex w-7 flex-shrink-0 items-center justify-center text-2xl leading-none"
            text={`:${displayEmoji.name}:`}
          />
        </div>
      )}
    </div>
  );
};

export default FooterSection;
